module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "the-arrow-academy-yearbook"
    }
  }, [_c('h1', [_vm._v("The Arrow Academy Yearbook")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "97%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "51%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("Junior class")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("Upper class")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Adelaide Abbott"), _c('br'), _vm._v(" 5"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v(" Telekinesis")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Caroline James "), _c('br'), _vm._v("12"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v(" Mind-Reading")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Brooklynn Black"), _c('br'), _vm._v("10th Grade"), _c('br'), _vm._v(" Mind-reading")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Henry Miller"), _c('br'), _vm._v("11"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v(" Telekinesis")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Dylann Robins"), _c('br'), _vm._v("5"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v("Shape shifting")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Jay Robinson"), _c('br'), _vm._v(" 12"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v(" Shape shifting")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Ian Royce"), _c('br'), _vm._v("5"), _c('sup', [_vm._v("th")]), _vm._v(" Grade "), _c('br'), _vm._v("Speed")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Katherine Cameron "), _c('br'), _vm._v("12"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v("Healing")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Isaac Abbott"), _c('br'), _vm._v(" 9"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v("Healing")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Levi Smith"), _c('br'), _vm._v(" 11"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v("Invisibility")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Jensen Mayers"), _c('br'), _vm._v("3"), _c('sup', [_vm._v("rd")]), _vm._v(" Grade"), _c('br'), _vm._v("Invisibility")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Reid Johnson"), _c('br'), _vm._v("11"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v("Strength")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Lincoln Ridge"), _c('br'), _vm._v("4"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v("Strength")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Timothy Keller"), _c('br'), _vm._v("12"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v("Flight")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Silas Jones"), _c('br'), _vm._v("6"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v("Flight")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Wendy Cortez"), _c('br'), _vm._v("11"), _c('sup', [_vm._v("th")]), _vm._v(" Grade"), _c('br'), _vm._v("Flight")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec7193a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 78
// module chunks = 0